import { createApiClient } from './client';
import { HttpError } from './errors';

const LOGOUT_ENDPOINT = '/v2/auth/logout';

export const LOGOUT_TIMEOUT_MS = 5_000;

const { request } = createApiClient({ onSessionLost: () => undefined, timeoutMs: LOGOUT_TIMEOUT_MS });

export const endServerSession = async (): Promise<void> => {
  await request('post', LOGOUT_ENDPOINT, { body: {} }).catch((error: unknown) => {
    if (error instanceof HttpError && error.status === 401) return;
    throw error;
  });
};
